<template>
  <div>
    <b-row>
      <!-- {{ GET_INSTRUMENT_CATEGORIES.results }} -->
      <!-- {{ product_categories }} -->
      <b-col cols="12">
        <b-row class="justify-content-between align-items-end">
          <b-col class="col-md-2">
            <AppSearchInput
              v-model="search"
              :label="$t('search') + ':'"
              :placeholder="$t('search') + '...'"
              @callback="onFiltered"
            />
          </b-col>
          <b-col class="col-md-2">
            <b-form-group :label="$t('filter_by_warehouses') + ':'">
              <v-select
                v-model="in_object"
                class="bg-white rounded"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :reduce="(data) => data.id"
                :options="GET_APPLICATION_TYPE"
                @input="onFiltered"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-md-2">
            <b-form-group :label="$t('filter_by_category') + ':'">
              <v-select
                v-model="categoryTable"
                class="bg-white rounded"
                label="title"
                :reduce="(data) => data.id"
                :options="
                  card
                    ? product_categories.results
                    : GET_INSTRUMENT_CATEGORIES.results
                "
                @input="onFiltered"
              >
                <li slot="list-footer" class="pagination">
                  <button
                    :disabled="
                      card
                        ? !product_categories.previous
                        : !GET_INSTRUMENT_CATEGORIES.previous
                    "
                    @click="previous1"
                  >
                    {{ $t("prev") }}
                  </button>
                  <button
                    :disabled="
                      card
                        ? !product_categories.next
                        : !GET_INSTRUMENT_CATEGORIES.next
                    "
                    @click="nextFunc1"
                  >
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col class="col-md-2">
            <b-form-group :label="$t('filter_by_type') + ':'">
              <v-select
                class="bg-white rounded"
                label="title"
                v-model="productType"
                :reduce="(data) => data.id"
                :options="
                  card ? GET_MATERIALS.results : GET_INSTRUMENTS_MODEL.results
                "
                @input="onFiltered"
                :filterable="false"
              >
                <li slot="list-footer" class="pagination">
                  <button
                    :disabled="
                      card
                        ? !GET_MATERIALS.previous
                        : !GET_INSTRUMENTS_MODEL.previous
                    "
                    @click="previous2"
                  >
                    {{ $t("prev") }}
                  </button>
                  <button
                    :disabled="
                      card ? !GET_MATERIALS.next : !GET_INSTRUMENTS_MODEL.next
                    "
                    @click="nextFunc2"
                  >
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col class="col-lg-3 col-md-3 col-12 ml-auto text-right">
            <b-form-radio-group
              id="radio-dark"
              v-model="card"
              class="mb-1 list item-view-radio-group"
              buttons
              button-variant="outline-primary"
              @input="onSelectType"
            >
              <b-form-radio
                v-for="option in itemViewOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
      </b-col>
      <b-col
        cols="12"
        class="mt-50"
        v-if="checkButtonPermission(['manager', 'chief_manager', 'admin'])"
      >
        <div class="d-flex justify-content-end align-items-center">
          
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="success"
            class="mb-1"
            @click="downloadExcel()"
          >
            <feather-icon icon="DownloadIcon" size="16" />
            {{ $t("excel") }}
          </b-button>
          <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mb-1"
            @click="onAddClicked"
          >
            <feather-icon icon="PlusIcon" size="16" />
            {{ $t("add") }}
          </b-button> -->
        </div>
      </b-col>
      <b-col>
        <b-row v-if="!isLoading">
          <b-col v-if="card" class="col-md-12">

            <b-card class="mb-1">
              <h6 class="mb-1">
                {{ $t("raw_materials") }} / {{ $t("reference.material") }}
              </h6>
              <material-table @row-selected="onSelected" />
            </b-card>

            <b-card no-body class="d-flex align-items">
              <Pagination
                class="mb-0 p-2"
                :nobody="true"
                :params="filter"
                :rows="GET_MATERIAL_REMAINS.count"
                @refresh="onFiltered"
              />
            </b-card>

          </b-col>
          <b-col v-else class="col-md-12">
            <b-card class="mb-1">
              <h6 class="mb-1">{{ $t("reference.instrument") }}</h6>
              <instruments-table @row-selected="onSelected2" />
            </b-card>
            <b-card no-body class="d-flex align-items">
              <Pagination
                class="mb-0 p-2"
                :nobody="true"
                :params="filterInstrument"
                :rows="GET_ISNTRUMENTS_REMAINS.count"
                @refresh="onFiltered"
              />
            </b-card>
          </b-col>
        </b-row>
        <b-card v-else>
          <Loader />
        </b-card>
      </b-col>
    </b-row>

    <add-entering-balance-modal @refresh="refresh" />
    <row-details :card="card" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormRadio,
  BFormRadioGroup,
  BFormGroup,
  BButton,
} from "bootstrap-vue";
import { mapActions, mapGetters, mapState } from "vuex";
import VSelect from "vue-select";
// import materialModal from './components/materialModal.vue'
// import instrumentModal from './components/instrumentModal.vue'
import Ripple from "vue-ripple-directive";
import AppSearchInput from "@/components/AppSearchInput.vue";
import InstrumentsTable from "./components/tables/InstrumentsTable.vue";
import MaterialTable from "./components/tables/MaterialTable.vue";
import Pagination from "@/components/Pagination.vue";
import addEnteringBalanceModal from "./components/addEnteringBalanceModal.vue";
import rowDetails from "./components/rowDetails.vue";
import check from "@/mixins/check.js";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    rowDetails,
    BRow,
    BCol,
    BCard,
    Loader,
    // materialModal,
    // instrumentModal,
    AppSearchInput,
    InstrumentsTable,
    MaterialTable,
    BFormGroup,
    BFormRadio,
    BFormRadioGroup,
    Pagination,
    addEnteringBalanceModal,
    VSelect,
    BButton,
  },
  directives: {
    Ripple,
  },
  mixins: [check, loader],
  data() {
    return {
      isLoading: false,
      categoryTable: null,
      card: true,
      timeline: false,
      productType: null,
      search: "",
      in_object: null,
      filter: {
        page_size: 10,
        page: 1,
      },
      filterInstrument: {
        page_size: 10,
        page: 1,
      },
      itemViewOptions: [
        {
          text: this.$t("reference.material"),
          value: true,
        },
        {
          text: this.$t("reference.instrument"),
          value: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("materials", ["GET_MATERIAL_REMAINS", "GET_MATERIALS"]),
    ...mapGetters("instruments", [
      "GET_INSTRUMENT_CATEGORIES",
      "GET_INSTRUMENTS_MODEL",
      "GET_INSTRUMENTS_MODEL_VARIANT",
    ]),
    ...mapState("materials", ["product_categories"]),
    ...mapGetters("instruments", [
      "GET_INSTRUMENTS_MODEL_VARIANT",
      "GET_ISNTRUMENTS_REMAINS",
    ]),
    ...mapGetters("application", ["GET_APPLICATION_TYPE"]),
  },
  watch: {
    card() {
      this.search = null;
      this.in_object = null;
      // this.onFiltered()
    },
  },

  async mounted() {
    // await this.$_loaderStart();
    this.isLoading = true;
    await this.FETCH_PRODUCT_CATEGORIES();
    await this.refresh()
    await this.FETCH_APPLICATION_TYPE({ is_object: true, mini: true });
    await this.FETCH_MATERIALS();
    await this.FETCH_INSTRUMENTS_CATEGORY();
    this.isLoading = false;
  },

  // async beforeRouteLeave(to, from, next) {
  //   await this.$_loaderStop();
  //   next();
  // },
  methods: {
    ...mapActions("instruments", [
      "FETCH_INSTRUMENT_REMAINS",
      "FETCH_INSTRUMENTS_CATEGORY",
      "FETCH_INSTRUMENTS_MODEL",
      "FETCH_INSTRUMENTS_MODAL_DETAILS",
    ]),
    ...mapActions("materials", [
      "FETCH_MATERIAL_REMAINS",
      "FETCH_MATERIAL_REMAINS_EXCEL",
      "FETCH_PRODUCT_CATEGORIES",
      "FETCH_MATERIALS",
      "FETCH_MODAL_DETAILS",
    ]),
    ...mapActions("application", ["FETCH_APPLICATION_TYPE"]),
    async refresh() {
      await this.FETCH_MATERIAL_REMAINS({...this.filter, search: this.search, in_object: this.in_object, product__category: this.categoryTable, product: this.productType});
      await this.FETCH_INSTRUMENT_REMAINS({...this.filterInstrument, search: this.search, in_object: this.in_object, type__category: this.categoryTable, type: this.productType});
    },
    // фильтр данных
    async onFiltered() {
      if (this.categoryTable) {
        if (this.card) {
          await this.FETCH_MATERIALS({ category: this.categoryTable });
        } else {
          await this.FETCH_INSTRUMENTS_MODEL({ category: this.categoryTable });
        }
      }
      if (!this.categoryTable) {
        if (this.card) {
          await this.FETCH_MATERIALS();
        } else {
          await this.FETCH_INSTRUMENTS_MODEL();
        }
      }
      if (this.card) {
        this.isLoading = true;

        await this.FETCH_MATERIAL_REMAINS({
          search: this.search,
          ...this.filter,
          in_object: this.in_object,
          product__category: this.categoryTable,
          product: this.productType,
        });
        this.isLoading = false;
      } else {
        this.isLoading = true;

        await this.FETCH_INSTRUMENT_REMAINS({
          search: this.search,
          ...this.filterInstrument,
          in_object: this.in_object,
          type__category: this.categoryTable,
          type: this.productType,
        });

        this.isLoading = false;
      }
    },

    async previous1() {
      if (this.card) {
        if (this.product_categories.previous) {
          this.filter.page--;
          await this.FETCH_PRODUCT_CATEGORIES({
            ...this.filter,
            category: this.categoryTable,
          });
        }
      } else {
        if (this.GET_INSTRUMENT_CATEGORIES.previous) {
          this.filterInstrument.page--;
          await this.FETCH_INSTRUMENTS_CATEGORY({
            ...this.filterInstrument,
            category: this.categoryTable,
          });
        }
      }
    },
    async nextFunc1() {
      if (this.card) {
        if (this.product_categories.next) {
          this.filter.page++;
          await this.FETCH_PRODUCT_CATEGORIES({
            ...this.filter,
            category: this.categoryTable,
          });
        }
      } else {
        if (this.GET_INSTRUMENT_CATEGORIES.next) {
          this.filterInstrument.page++;
          await this.FETCH_INSTRUMENTS_CATEGORY({
            ...this.filterInstrument,
            category: this.categoryTable,
          });
        }
      }
    },

    async previous2() {
      if (this.card) {
        if (this.GET_MATERIALS.previous) {
          this.filter.page--;
          await this.FETCH_MATERIALS({
            ...this.filter,
            category: this.categoryTable,
          });
        }
      } else {
        if (this.GET_INSTRUMENTS_MODEL.previous) {
          this.filterInstrument.page--;
          await this.FETCH_INSTRUMENTS_MODEL({
            ...this.filterInstrument,
            category: this.categoryTable,
          });
        }
      }
    },
    async nextFunc2() {
      if (this.card) {
        if (this.GET_MATERIALS.next) {
          this.filter.page++;
          await this.FETCH_MATERIALS({
            ...this.filter,
            category: this.categoryTable,
          });
        }
      } else {
        if (this.GET_INSTRUMENTS_MODEL.next) {
          this.filterInstrument.page++;
          await this.FETCH_INSTRUMENTS_MODEL({
            ...this.filterInstrument,
            category: this.categoryTable,
          });
        }
      }
    },
    // Выбор типа
    onSelectType() {
      this.filter.search = "";
    },
    // Выбор материала или инструмента
    onSelected(event) {
      this.FETCH_MODAL_DETAILS(event.id).then(() => {
        this.$nextTick(() => {
          this.$bvModal.show("addModalDetails");
        });
      });
    },
    onSelected2(event) {
      this.FETCH_INSTRUMENTS_MODAL_DETAILS(event.id).then(() => {
        this.$nextTick(() => {
          this.$bvModal.show("addModalDetails");
        });
      });
    },
    downloadExcel() {
      this.FETCH_MATERIAL_REMAINS_EXCEL({excel: true}).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'file.xls')
        document.body.appendChild(link)
        link.click()
      });
    },
    // onAddClicked() {
    //   this.$bvModal.show("addEnteringBalanceModal");
    // },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.dark-layout #radio-dark  label{
  color: #fff  !important;
}

//  кнопка переключения между заявками и инструментами
[dir] .btn-outline-primary:not(:disabled):not(.disabled).active {
  background-color: #5a9cd9;
  color: white;
}


.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
